// extracted by mini-css-extract-plugin
export default {"melodyVideo":"mK-z","isFullWidth":"nK-z","landingPageVideo":"oK-z","play":"pK-z","iframeVideo":"qK-z","playHidden":"rK-z","fullwidth":"sK-z"};